import { render, staticRenderFns } from "./Edocs.vue?vue&type=template&id=71b14dba"
import script from "./Edocs.vue?vue&type=script&lang=js"
export * from "./Edocs.vue?vue&type=script&lang=js"
import style0 from "./Edocs.vue?vue&type=style&index=0&id=71b14dba&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports